import { print } from 'graphql';
import gql from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { BaseEntity } from '../../models/BaseEntity';
import { generatePullQuery, PullQueryContext } from '../queryBuilders/generatePullQuery';
import { defaultDocAllTime } from '../Shared/defaultDoc';

export interface Position extends BaseEntity {
  readonly description: string;
}

export type PositionCollection = RxCollection<Position> | null;
export type PositionDocument = RxDocument<Position>;

export const positionSchema: RxJsonSchema<Position> = {
  type: 'object',
  version: 0,
  description: 'describes a position object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    description: { type: 'string' },
    isDeleted: { type: 'boolean' },
    updatedAt: { type: 'number' },
    version: { type: 'number' },
  },
};

const positionFeedQuery = print(gql`
  query positionFeed($lastUpdateAt: Float!, $siteId: ID!, $limit: Int!) {
    positionFeed(siteId: $siteId, lastUpdateAt: $lastUpdateAt, limit: $limit) {
      id
      description
      isDeleted
      updatedAt
      version
    }
  }
`);

export const positionPullQueryBuilder = generatePullQuery(
  positionFeedQuery,
  PullQueryContext.Site,
  defaultDocAllTime,
);
